/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, ButtonToolbar, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { NoticeManajemenUser } from "../../../../../_metronic/_partials/controls";
import AppConfig from "../../../../config/AppConfig";

class ManajemenUser extends Component {
  state = {
    // ==================================
    loadingBtn: false,
    loadingForm: true,
    // ==================================
    errors: [],
    old_password: "",
  };

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  componentDidMount() {
    const timer = setTimeout(() => this.setState({ loadingForm: false }), 1000);
    return () => clearTimeout(timer);
  }

  validateForm() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.old_password) {
      formIsValid = false;
      errors["old_password"] = "Isian password lama Anda tidak boleh kosong.";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  // Reset Password ============================================================================
  handleSave = (e) => {
    e.preventDefault();
    e.target.className += " was-validated";
    if (this.validateForm()) {
      this.setState({ loadingBtn: true });
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          // "?token="+userdata.token+`
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      axios
        .post(AppConfig.ResetPassword, userdata.id_pengguna + session)
        .then((res) => {
          this.setState({
            loadingBtn: false,
          });
          if (res.data.status === "sukses") {
            swal({
              title: "Reset password berhasil!",
              text: "Password yang berlaku adalah <b>username</b> anda",
              icon: "success",
              button: "Ok!",
            }).then(() => {
              // Go to list user
            });
          } else {
            swal({
              title: "Reset password gagal!",
              text: "Silahkan ulangi sekali lagi",
              icon: "error",
              button: "OK!",
            });
          }
        })
        .catch((err) => {
          swal({
            title: "Reset password gagal!",
            text: "Silahkan ulangi sekali lagi",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        });
    }
  };

  // Layout ============================================================================
  render() {
    // let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    return (
      <>
        <NoticeManajemenUser style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Manajemen User</strong>
          <p>Pengaturan User SPMI</p>
        </NoticeManajemenUser>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <h2>Form Reset Password</h2>
                </div>
              </div>
            </div>
          </div>
          {/*========================================== Form Reset Password ========================================== */}
          <Form
            className="needs-validation"
            onSubmit={this.handleSave}
            noValidate
          >
            {this.state.loadingForm === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* For turning off auto complete */}
                <input type="hidden" value="something" />
                <Form.Row>
                  <Form.Group as={Col} controlId="old_password">
                    <Form.Label>
                      Password Lama <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Masukkan password lama.."
                      value={this.state.old_password}
                      onChange={(e) => this.onInputForm(e, "old_password")}
                      required
                    />
                    <div className="invalid-feedback">
                      {this.state.errors.old_password}
                    </div>
                  </Form.Group>
                </Form.Row>

                <div className="row">
                  <div className="col-md-12">
                    <div style={{ float: "right", marginLeft: "10px" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Button
                            disabled={this.state.loadingBtn}
                            variant="primary"
                            type="submit"
                          >
                            Simpan
                            {this.state.loadingBtn && (
                              <i className="ml-2 mr-1 spinner spinner-white"></i>
                            )}
                            &nbsp;&nbsp;
                          </Button>
                        </span>
                      </ButtonToolbar>
                    </div>
                    <div style={{ float: "right" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Link to="/user">
                            <Button
                              variant="secondary"
                              disabled={this.state.loadingBtn}
                            >
                              Kembali
                            </Button>
                          </Link>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
          {/*========================================== End Form ========================================== */}
        </Card>
      </>
    );
  }
}

export default ManajemenUser;
